import { render, staticRenderFns } from "./OrderManagementAll.vue?vue&type=template&id=00d537f0&scoped=true&"
import script from "./OrderManagementAll.vue?vue&type=script&lang=js&"
export * from "./OrderManagementAll.vue?vue&type=script&lang=js&"
import style0 from "./OrderManagementAll.vue?vue&type=style&index=0&id=00d537f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d537f0",
  null
  
)

export default component.exports